
import Home from "@mui/icons-material/Home";
import Business from "@mui/icons-material/Business";
import BarChart from '@mui/icons-material/BarChart';
import Api from '@mui/icons-material/Api';
import Info from '@mui/icons-material/Info';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import BugReportIcon from '@mui/icons-material/BugReport';
import MonitorWeight from '@mui/icons-material/MonitorWeight';
import Scale from '@mui/icons-material/Scale';
import AssessessmentIcon from '@mui/icons-material/Assessment';
import PieChart from '@mui/icons-material/PieChart';
import Forum from '@mui/icons-material/Forum';
import Visibility from '@mui/icons-material/Visibility';
import People from '@mui/icons-material/People';
import WarningIcon from '@mui/icons-material/Warning';
import AdjustIcon from '@mui/icons-material/Adjust';
import ShieldIcon from '@mui/icons-material/Shield';
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline';

import ExecutiveView from "pages/ExecutiveView/ExecutiveView";
import Organization from "pages/Organization/Organization";
import Context from "pages/Context/Context";
import SecurityAspects from "pages/SecurityAspects/SecurityAspects";
import Impact from "pages/Impact/Impact";
import ThreatsProbability from "pages/ThreatsProbability/ThreatsProbability";
import ThreatsContextProbability from "pages/ThreatsContextProbability/ThreatsContextProbability";
import VulnerabilityWeights from "pages/VulnerabilityWeights/VulnerabilityWeights";
import SubcategoryWeights from "pages/SubcategoryWeights/SubcategoryWeights";
import Status from "pages/Status/Status";
import Assessment from "pages/Assessment/Assessment";
import Questionnaire from "pages/Questionnaire/Questionnaire";
import Score from "pages/Score/Score";
import Treatments from "pages/Treatments/Treatments";
import Risks from "pages/Risks/Risks";
import Users from "pages/Users/Users";
import Strategy from "pages/Strategy/Strategy";
import Plan from "pages/Plan/Plan";

interface Route {
  path: string;
  basePath?: string;
  element: JSX.Element;
  name: string;
  icon: any;
  protected: boolean;
  condition?: () => boolean;
}

export const dashboard = [
  {
    path: "/tenant-executive-view",
    element: <ExecutiveView />,
    name: "Tenant Executive View",
    icon: Home,
    protected: true
  },
] as Route[];

export const settings = [
  {
    path: "/organization",
    element: <Organization />,
    name: "Organization",
    icon: Business,
    protected: true
  },
  {
    path: "/assessment",
    element: <Assessment />,
    name: "Assessment",
    icon: AssessessmentIcon,
    protected: true,
    condition: () => localStorage.getItem('currentOrganization') ? true : false
  },
  {
    path: "/users",
    element: <Users />,
    name: "Users",
    icon: People,
    protected: true,
  }
] as Route[];

export const riskTreatment = [
  {
    path: "/assessment/strategy",
    element: <Strategy />,
    name: "Strategy",
    icon: AdjustIcon,
    protected: true,
    condition: () => true
  },
  {
    path: "/assessment/treatments",
    element: <Treatments />,
    name: "Treatments",
    icon: ShieldIcon,
    protected: true,
    condition: () => true
  },
  {
    path: "/assessment/plan",
    element: <Plan />,
    name: "Plan",
    icon: ViewTimelineIcon,
    protected: true,
    condition: () => true
  }
] as Route[];

export const scope = [
  {
    path: "/scope/context",
    element: <Context />,
    name: "Context",
    icon: Info,
    protected: true,
    'condition': () => { 
      return localStorage.getItem('currentAssessment') && [2,3].includes(JSON.parse(localStorage.getItem('user')??'{}').id_role) ? true : false
    }
  },  
  {
    path: "/scope/security-aspects",
    element: <SecurityAspects />,
    name: "Security aspects",
    icon: Info,
    protected: true,
    'condition': () => { 
      return localStorage.getItem('currentAssessment') && [2,3].includes(JSON.parse(localStorage.getItem('user')??'{}').id_role) ? true : false
    }
  }] as Route[];
  export const riskAssessment = [
  {
    path: "/scope/impact",
    element: <Impact />,
    name: "Impact",
    icon: GppMaybeIcon,
    protected: true,
    'condition': () => { 
      return localStorage.getItem('currentAssessment') && [2,3].includes(JSON.parse(localStorage.getItem('user')??'{}').id_role) ? true : false
    }
  },
  {
    path: "/scope/threats-context-probability",
    element: <ThreatsContextProbability />,
    name: "Threats",
    icon: BugReportIcon,
    protected: true,
    'condition': () => { 
      return localStorage.getItem('currentAssessment') && [2,3].includes(JSON.parse(localStorage.getItem('user')??'{}').id_role) ? true : false
    }
  },
  {
    path: "/assessment/questionnaire/:id_category?/:id_subcategory?/:id_control?",
    basePath: "/assessment/questionnaire",
    element: <Questionnaire />,
    name: "Questionnaire",
    icon: Forum,
    protected: true,
    condition: () => localStorage.getItem('currentAssessment') ? true : false
  },
  {
    path: "/assessment/status",
    element: <Status />,
    name: "Status",
    icon: PieChart,
    protected: true,
    'condition': () => { 
      return localStorage.getItem('currentAssessment') && [2,3].includes(JSON.parse(localStorage.getItem('user')??'{}').id_role) ? true : false
    }
  },
  {
    path: "/assessment/eagle-view",
    element: <Score />,
    name: "Eagle View",
    icon: Visibility,
    protected: true,
    'condition': () => { 
      return localStorage.getItem('currentAssessment') && [2,3].includes(JSON.parse(localStorage.getItem('user')??'{}').id_role) ? true : false
    }
  },
  {
    path: "/assessment/risks",
    element: <Risks />,
    name: "Risks",
    icon: WarningIcon,
    protected: true,
    'condition': () => { 
      return localStorage.getItem('currentAssessment') && [2,3].includes(JSON.parse(localStorage.getItem('user')??'{}').id_role) ? true : false
    }
  },
]
export const metodology = [
  {
    path: "/scope/threats-probability",
    element: <ThreatsProbability />,
    name: "Threats Probability",
    icon: BugReportIcon,
    protected: true,
    'condition': () => { 
      return [2,3].includes(JSON.parse(localStorage.getItem('user')??'{}').id_role) ? true : false
    }
  },
  {
    path: "/scope/vulnerability-weights",
    element: <VulnerabilityWeights />,
    name: "Vulnerability Weights",
    icon: MonitorWeight,
    protected: true
  },
  {
    path: "/scope/subcategory-weights",
    element: <SubcategoryWeights />,
    name: "Subcategory Weights",
    icon: Scale,
    protected: true
  },
] as Route[];

export const routes = [
  {
    'title':'Dashboard',
    'collapsible': true,
    'values': dashboard
  },
  {
    'title':'Scope',
    'collapsible': true,
    'values': scope,
    'condition': () => { 
      return localStorage.getItem('currentAssessment') && [2,3].includes(JSON.parse(localStorage.getItem('user')??'{}').id_role) ? true : false
    }
  },
  { 
    'title': 'Risk Assessment',
    'collapsible': true,
    'values':riskAssessment,
    'condition': () => { 
      return localStorage.getItem('currentAssessment') ? true : false
    }
  },
  { 
    'title': 'Risk Treatment',
    'collapsible': true,
    'values':riskTreatment,
    'condition': () => { 
      return localStorage.getItem('currentAssessment') && [2,3].includes(JSON.parse(localStorage.getItem('user')??'{}').id_role) ? true : false
    }
  },
  { 
    'title': 'Settings',
    'collapsible': true,
    'values':settings,
    'condition': () => 
      [2].includes(JSON.parse(localStorage.getItem('user')??'{}').id_role) ? true : false
  },
  { 
    'title': 'Metodology',
    'collapsible': true,
    'values':metodology,
    'condition': () => 
      localStorage.getItem('currentOrganization') &&
      [2].includes(JSON.parse(localStorage.getItem('user')??'{}').id_role) ? true : false
  }
];